module.exports = __webpack_public_path__ + "assets/img/supplier_level3.9448c9d2.svg";